<template lang="pug">
modal(:active="true", title="Responder mensagem", @close="close")
  div(slot="modal-body")
    form(@submit.prevent="responder")
      .form-group
        label.form-label(for="conteudo") {{ "mensagem.conteudo" | tModel }}
        textarea#conteudo.form-input(rows="5", v-model="mensagem.conteudo")
      button.btn.btn-primary.float-right.btn-lg(:disabled="invalid") Enviar
</template>

<script>
import toastErrors from "@/lib/errors/toastErrors";

export default {
  vuex: { "mensagens/recebidas": { actions: ["fetchResponder", "fetchOne"] } },
  computed: {
    invalid() {
      return !this.mensagem.conteudo;
    },
  },
  data() {
    return {
      mensagem: { conteudo: "", mensagem_id: parseInt(this.$route.params.id) },
    };
  },
  methods: {
    async responder() {
      try {
        await this.fetchResponder({
          id: this.mensagem.mensagem_id,
          resposta: this.mensagem,
        });
        await this.fetchOne(this.mensagem.mensagem_id);
        this.$toaster.success("Mensagem respondida");
        this.close();
      } catch (e) {
        toastErrors(e);
      }
    },
    close() {
      this.$router.replace(
        `/app/mensagens/recebidas/${this.mensagem.mensagem_id}`
      );
    },
  },
};
</script>
